import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.64645 0.146447C8.84171 -0.0488155 9.15829 -0.0488155 9.35355 0.146447C9.5338 0.326689 9.54766 0.610304 9.39515 0.80645L9.35355 0.853553L3.85355 6.35355C3.67331 6.5338 3.3897 6.54766 3.19355 6.39515L3.14645 6.35355L0.646447 3.85355C0.451184 3.65829 0.451184 3.34171 0.646447 3.14645C0.826689 2.9662 1.1103 2.95234 1.30645 3.10485L1.35355 3.14645L3.5 5.2925L8.64645 0.146447Z"
        fill="white"
      />
    </Svg>
  );
};

export default Icon;
